export const getUserRole = (): string => {
  return localStorage.getItem("role")?.toLowerCase() || "";
};

export const isProjectManager = (): boolean => {
  return getUserRole() === "project manager";
};

export const isCommercial = (): boolean => {
  return getUserRole() === "commercial";
};

export const isSMT = (): boolean => {
  return getUserRole() === "smt";
};

export const isAdmin = (): boolean => {
    return getUserRole() === "admin";
};
export const hasAdminSMTCommercialAccess = (): boolean => {
  const role = getUserRole();
  return role === "admin" || role === "smt" || role === "commercial";
};